<template>
  <div class="newbg">
    <div class="hxq_subpage">
      <div class="newHeader">
        <div class="hello">
          <div class="header">
            <div class="w1200 clearfix">
              <div class="header_l">
                欢迎光临志鹏供应链<em><img src="../../assets/images/zp_01.png">&ensp;400-040-7890</em>
              </div>
              <div class="header_r">
                <a href="javascript:;" class="ewm_btn">手机版<em><img src="../../assets/images/qr000.png" alt=""></em></a>
                <em v-if="!current_user.id">
                  <router-link :to="{path:'/Login',query: {return_url: return_url}}" class="login_btn">登录</router-link>
                  <router-link :to="{path:'/Register'}" class="register_btn">注册</router-link>
                </em>
                <em v-else>
                  <router-link :to="{path:'/MyOrder'}" class="wddd_btn">我的订单</router-link>
                  <a href="javascript:;" class="login_btn" @click="logout">退出</a>
                  <router-link :to="{path:'/PersonalData'}" style="color:#76a9f6;">欢迎-{{current_user.name || current_user.tel}}</router-link>
                </em>
              </div>
            </div>
          </div>
          <!-- search -->
          <div class="header_search clearfix w1200">
            <a href="/" target="_blank" title="志鹏供应链（内蒙古）有限公司" class="header_search_l">
              <img src="../../assets/kit/zp_06new.png" width="355" height="90">
            </a>
            <div class="header_search_c">
              <el-input placeholder="请输入内容" v-model="searchMsg" class="input-with-select" :class="isActive?'searchStyle':'searchGray'" :clearable="true" @keyup.enter.native="mySearch" @blur="blur" @focus="focus">
                <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                  <el-option label="标题" value="1"></el-option>
                  <el-option label="代码" value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="mySearch"></el-button>
              </el-input>
              <div class="header_search_cb">
                <a href="javascript:;" v-for="(item,index) in keywords" :key="index" >
                  <em @click="searchKwywords(item.title)" style="color:#fff;">{{item.title}}</em>
                </a>
              </div>
            </div>
            <div class="header_search_r">
              <router-link :to="{path:'/Cart'}" style="color:#fff;">
                <img src="../../assets/kit/zp_07.png"> 购物车 <em class="red" v-if="cartCount">{{cartCount}}</em>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="buttonList">
        <ul class="buttonListul">
          <li class="thisbutton" @click="switchclass(item.id)" v-for="(item,index) in classification" :key="index">{{item.title}}</li>
        </ul>
      </div>
      <div class="bgcolor">
        <div class="hxq_ppsp">
          <div class="hxq_fllb_sx">
            <div class="hxq_ppsp_box" v-loading="qyloading">
              <ul class="hxq_ppsp_ul clearfix">
                <li v-for="(item,index) in list" :key="index" class="this_page_css" style="position:relative;">
                  <div class="listone"></div>
                  <div class="listtwo">
                    <img class="agreement" src="../../assets/images/xy11.png" v-if="item.pid && current_user.id && current_user.company_id != 1">
                    <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.title">
                      <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" :alt="item.title" width="210" height="210" style="margin-left:10px;">
                    </router-link>
                    <h3>
                      <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" class="this_page_title" target="_blank" :title="item.title">{{ item.title }}</router-link>
                    </h3>
                    <div class="hxq_ppsp_ul_jg">
                      <em style="font-size:0;">
                        <span v-if="item.tax_price && item.tax_price > 0" style="font-weight:bold;">￥</span>
                        <span v-if="item.tax_price && item.tax_price > 0" style="font-weight:bold;">{{ item.tax_price }}</span>
                        <span v-else style="font-weight:bold">询价</span>
                        <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-if="item.delivery_time">
                          {{ item.delivery_time }}日出货
                        </i>
                        <i style="display: block;width: 67px;height: 25px;background: #fe722c;text-align: center;font-size: 12px;line-height: 25px;color: #fff;border-radius: 4px;float:right;" v-else>
                          当日出货
                        </i>
                      </em>
                    </div>
                    <div class="hxq_ppsp_ul_join clearfix">
                      <div class="hxq_ppsp_ul_join_l" style="height: 20px;">
                        <p>订货号：{{ item.sku }}</p>
                        <!--<p>库存：<if condition="$vo['number'] gt 0">{$vo['number']}<else/>0</if>销量：{$vo['salescount'] | default='0'}</p>-->
                      </div>
                    </div>
                    <div class="hxq_ppsp_ul_join clearfix">
                      <div class="hs-collect" style="height: 32px;line-height: 32px;">
                        <el-button v-if="item.isCollect" type="warning" :autofocus="true" size="small" icon="el-icon-star-on" style="float:left;" @click="collect(item)">已收藏</el-button>
                        <el-button v-else type="warning" :autofocus="true" size="small" icon="el-icon-star-off" style="float:left;" @click="collect(item)">收藏</el-button>
                        <el-button type="primary" plain size="small" icon="el-icon-shopping-cart-full" style="float:right;" @click="addCart(item)">加入购物车</el-button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="cght_cnxhtiwtjsp" v-if="emptyShow && list.length==0">
                <div>
                  <em class="myemptydata">暂无数据</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
    </div>
    <Footer/>
  </div>
</template>
<script>
import api from '@/api/goods'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import { mapGetters } from 'vuex'

export default {
  name: 'Hotcake',
  mixins: [vuelist],
  inject: ['reload'], // 注入依赖
  components: { Pagination, Navigationzj, Footer },
  data () {
    return {
      api,
      return_url: this.$route.fullPath,
      qyloading: false,
      emptyShow: false,
      searchType: '1',
      searchMsg: '',
      isActive: false,
      classification: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user',
      'cartCount',
      'keywords'
    ])
  },
  watch: {
    $route (to, from) {
      this.reload()
    }
  },
  mounted () {
    if (this.current_user.id) {
      this.$store.dispatch('cart/getCartCount')
    }
    this.$store.dispatch('cart/getSearchKeywords')
    this.switchclass(1472)
    api.goodsCategory().then(res => {
      this.classification = res.item
    })
  },
  methods: {
    afterLoadData (list) {
      list.forEach(res => {
        if (res.specParamList) { res.specParamList = JSON.parse(res.specParamList) }
      })
      this.emptyShow = true
      return list
    },
    // 收藏
    collect (item) {
      if (!this.current_user || !this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      api.delOrAddCollect({'member_id': this.current_user.id, 'goods_id': item.id}).then(res => {
        item.isCollect = item.isCollect === 1 ? 0 : 1
      })
    },
    addCart (item) {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return false
      }
      console.info(item)
      api.addCart({
        'id': item.id,
        'leaveMessage': item.leaveMessage
      }).then(response => {
        this.$notify({
          title: '加入购物车',
          message: '添加成功',
          type: 'success'
        })
      })
    },
    // 头部
    async logout () {
      await this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' })
      }
    },
    mySearch () {
      if (!this.searchMsg) {
        this.$message.error('请输入要搜索的产品名称或产品代码')
        return false
      }
      if (this.searchMsg && this.searchType === '1') {
        this.$router.push({name: 'Search', query: {keywords: this.searchMsg, searchType: this.searchType}})
      } else {
        this.$router.push({name: 'GoodsDetail', query: {sku: this.searchMsg}})
      }
    },
    searchKwywords (title) {
      this.$router.push({name: 'Search', query: {keywords: title, searchType: 1}})
    },
    blur () {
      this.isActive = false
    },
    focus () {
      this.isActive = true
    },
    switchclass (id) {
      const params = {
        limit: '20',
        order: 'id',
        page: '1',
        sort: 'DESC',
        category_id: id
      }
      api.getHotcakeList(params).then(res => {
        this.list = res.items
        if (this.list.length === 0) {
          this.emptyShow = true
        }
      })
    }
  }
}
</script>
<style scoped>
  .header_search_r:hover{
    border: 1px solid #fdff82;
  }
  .newHeader{
    width: 100%;
    height: 277px;
    background:url('../../assets/kit/435673.png') no-repeat;
    background-size:cover;
  }
  .thisbutton{
    width: 160px;
    height: 45px;
    float: left;
    margin-left: 30px;
    margin-top: 12px;
    cursor:pointer;
    line-height: 45px;
  }
  .thisbutton img{
    width: 100%;
  }
  .buttonList{
    width: 100%;
    margin: 0 auto;
    height: 65px;
    line-height: 65px;
    background-color: #fff;
    background:url('../../assets/kit/titelbg1.png');
  }
  .buttonListul{
    width: 1200px;
    margin: 0 auto;
  }
  .newbg{
    background-color: #ddeaf8;
  }
  .agreement{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 12;
    width: 60px;
  }
  .agreement_list{
    background-image:url('../../assets/images/xy22.png');
    background-repeat: no-repeat;
    background-position: right top;
    background-size: 70px 70px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .this_page_title{
    padding: 0 7px 0 7px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
  .hxq_ppsp_ul_jg {
    padding: 0 7px 0 7px;
  }
  .hxq_ppsp_ul_join{
    padding: 0 7px 0 7px;
  }
  .this_page_css {
    margin: 30px 50px 0 0;
    padding: 3px 0px 10px 0px;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
    width:250px;
    background:url('../../assets/kit/topbg.png') no-repeat;
    background-size:100%;
  }
  .listone{
    height: 40px;
  }
  .listtwo{
    border:10px solid #a5c5f0;
    padding-bottom: 10px;
    background-color: #fff;
    border-radius: 0 0 15px 15px;
  }
  .this_page_css:hover {
    /* box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5; */
    transform: translate(0, -10px);
  }
  .pagination-container {
    background: transparent !important;
  }
  .this_page_li {
    margin: 15px 0;
    -webkit-transition: all 0.25s ease-out;
    -o-transition: all 0.25s ease-out;
    transition: all 0.25s ease-out;
  }
  .this_page_li:hover {
    box-shadow: 0 0 5px #cbdaf5;
    -webkit-box-shadow: 0 0 5px #cbdaf5;
    -moz-box-shadow: 0 0 5px #cbdaf5;
    transform: translate(0, -10px);
  }
  .fllbsmall_con_bottom_1l img {
    border: none;
  }
  .fllbsmall_con_bottom li{
    border: none;
    padding: 5px 0;
  }
  .myborder{
    height: 34px;
    line-height: 34px;
    border-bottom: none !important;
  }
  .selectTrue{
    float: left;
    padding: 6px;
    border: 1px solid #cccccc;
    border-radius: 3px;
    margin-left: 18px;
    margin-bottom:12px;
  }
  .delSelect{
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    color:#fff;
    line-height: 20px;
    text-align: center;
    font-weight: bold;
    background: #4b8df9;
  }
  .hxq_fllb_ysz_yj{
    transition: all .5s ease;
    overflow: hidden;
    box-sizing: border-box;
  }
  .hxq_fllb_ysz .hxq_fllb_ysz_yj{
    padding: 0;
    border: none;
  }
  .el-radio{
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
.cght_cnxhtiwtjsp{ height:167px; width:100%; padding-top:175px;}
.cght_cnxhtiwtjsp div{ width:144px; text-align:center; padding-left:100px; background:url(../../assets/images/spsc_img02.png) no-repeat left center; height:60px; line-height:60px;font-size:18px; color:#959595; margin:0px auto; clear:both;}
  .myemptydata {color:#959595}
  .el-select{
    width: 90px!important;
  }
  .input-with-select{
    color: #fff;
  }
  ::v-deep.input-with-select .el-input-group__prepend {
    background-color: transparent;
  }
  ::v-deep.input-with-select .el-input__inner {
    background-color: transparent;
    color:#fff !important;
  }
  ::v-deep.input-with-select .el-input-group__append {
    background-color: transparent;
  }
  ::v-deep.input-with-select .el-input-group__append .el-icon-search {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/view/goods/hotcake.vue